import React from 'react';
import { useEventTags } from '../../../../data/hooks/tags/useEventTags';
import Tags from '../../../elements/Tags/Tags';

function EventDirectoryTags(props) {
    const {className = '', event, item} = props,
        categories = useEventTags(event.id);

    return <Tags className={className} categories={categories} tags={item.tags} />;
}

export default EventDirectoryTags;
